import { render, staticRenderFns } from "./reviewMessage.vue?vue&type=template&id=2ae41601&scoped=true"
import script from "./reviewMessage.vue?vue&type=script&lang=js"
export * from "./reviewMessage.vue?vue&type=script&lang=js"
import style0 from "./reviewMessage.vue?vue&type=style&index=0&id=2ae41601&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae41601",
  null
  
)

export default component.exports